import { render, staticRenderFns } from "./player-aside-panel.vue?vue&type=template&id=8f3eaf7c&"
import script from "./player-aside-panel.vue?vue&type=script&lang=js&"
export * from "./player-aside-panel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports